import { useState, useEffect } from 'react';
import { Grid } from '@mui/material';

import { useAuth } from "../../common/context/clientContext";
import { axiosPost } from "../../common/services/axios/apiCalls"
import SetLoading from "../../common/components/modals/setLoadingModal";
import { NoResults } from "../../common/utils/notDataUtils"

import ProductButton from '../button/productButton';

function GroupProductsCard({ groupCode }) {
    /** CONST */
    const { token } = useAuth()
    const [loading, setLoading] = useState(true)
    const [products, setProducts] = useState([])

    const getGroupProductsInfo = async () => {
        const axiosData = {
            code: groupCode
        }

        try {
            const response = await axiosPost("/public/catalog/group/product/read", token, axiosData)
            setLoading(false);
            return response.data
        } catch (error) {
            setLoading(false);
        }
    }

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            setProducts(await getGroupProductsInfo() || [])
        };

        fetchData();
    }, [])

    return (
        <>
            {loading && <SetLoading />}
            {!loading && (
                <>
                    {products.length > 0 ? (
                        products.map((product, pidx) => (
                            <Grid item sm={6} md={4} lg={3} sx={{ p: 2 }} id="product-card-grid" key={product.code + pidx}>
                                <ProductButton
                                    route={`product/${product.code}`}
                                    title={product.name}
                                    subtitle={product.short_description}
                                    status={product.status}
                                />
                            </Grid>
                        ))
                    ) : (<NoResults text={'No se encontraron equipos para esta selección'} />
                    )}
                </>
            )}
        </>
    );
}

export default GroupProductsCard